import useRegionBasedLinkQuery from './useRegionBasedLinkQuery'

/**
 * @param {Object} params
 * @param {string} params.region
 */
const useCharityLinkQuery = ({ region }) =>
  useRegionBasedLinkQuery({ region, endpoint: 'workplaces/charity-link', queryKey: 'charityLink' })

export default useCharityLinkQuery
